/**
 * /src/app.js
 */
import "../css/style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// cross-origin iframe (YouTube等) へのアクセスによるSecurityErrorを防ぐ
ScrollTrigger.config({
  ignoreMobileResize: true,
  autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
});

// ==============================
// details/summaryの開閉アニメーション
// ==============================
const initDetailsAnimation = () => {
  // アニメーションの時間とイージング
  const animTiming = {
    duration: 100,
    easing: "ease-in-out",
  };

  // アコーディオンを閉じるときのキーフレーム
  const closingAnimation = content => [
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];

  // アコーディオンを開くときのキーフレーム
  const openingAnimation = content => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: content.offsetHeight + "px",
      opacity: 1,
    },
  ];

  for (const el of document.querySelectorAll("details.js-accordion")) {
    const summary = el.querySelector("summary");

    if (!summary) {
      continue;
    }

    // summary以降の要素を.js-accordion__contentで囲む
    let content = el.querySelector(".js-accordion__content");
    if (!content) {
      // まだラップされていない場合、ラップ用のdivを作成
      content = document.createElement("div");
      content.className = "js-accordion__content";

      // summaryの次の兄弟要素から全てを取得してcontentに移動
      const siblings = [];
      let nextElement = summary.nextElementSibling;
      while (nextElement) {
        siblings.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      // 取得した要素をcontentに追加
      siblings.forEach(sibling => {
        content.appendChild(sibling);
      });

      // contentをdetailsに追加
      el.appendChild(content);
    }

    summary.addEventListener("click", event => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // detailsのopen属性を判定
      if (el.getAttribute("open") === null) {
        // open属性を付与
        el.setAttribute("open", "true");
        // アコーディオンを開くときの処理
        content.animate(openingAnimation(content), animTiming);
      } else {
        // アコーディオンを閉じるときの処理
        const closingAnim = content.animate(closingAnimation(content), animTiming);

        closingAnim.onfinish = () => {
          // アニメーションの完了後にopen属性を取り除く
          el.removeAttribute("open");
        };
      }
    });
  }
};

// ==============================
// .animate 要素のスクロールアニメーション
// ==============================
const initScrollAnimation = () => {
  const elements = document.querySelectorAll(".animate");
  if (!elements.length) return;

  elements.forEach(el => {
    gsap.from(el, {
      y: 20,
      scale: 0.9,
      opacity: 0,
      duration: 0.5,
      ease: "back.out(3)",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
      },
    });
  });
};

// ==============================
// .p-home__float の表示制御
// ==============================
const initFloatVisibility = () => {
  const float = document.querySelector(".p-home__float");
  const fv = document.querySelector(".p-home__fv");
  if (!float || !fv) return;

  ScrollTrigger.create({
    trigger: fv,
    start: "bottom top",
    onEnter: () => float.classList.add("is-visible"),
    onLeaveBack: () => float.classList.remove("is-visible"),
  });
};

// ==============================
// 初期化処理
// ==============================
const initialize = () => {
  initDetailsAnimation();
  initScrollAnimation();
  initFloatVisibility();
};

document.addEventListener("DOMContentLoaded", () => {
  initialize();
});
